import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Estacionamento } from './estacionamento.model';
import { Observable } from 'rxjs';
import { AppFilter } from "app/models/app-filter.model";
import { AbEstacionamento } from 'app/abstract/full-pages/estacionamento/estacionamento.abstract';


@Injectable({ providedIn: 'root' })
export class EstacionamentoService extends AbEstacionamento {

  constructor(http: HttpClient) {
    super(http);
  }

  public getAllEstacionamentos(filter: AppFilter): Observable<any> {
    return this.get(`estacionamentos/filter_estacionamento/${filter.encode()}`);
  }

  public getAllEstacionamentosList(filter: AppFilter): Observable<any> {
    return this.get(`estacionamentos/filter_estacionamento_list/${filter.encode()}`);
  }

  public getAllEstacionamentosTipoVagaList(filter: AppFilter): Observable<any> {
    return this.get(`estacionamentos/filter_estacionamento_tipovaga_list/${filter.encode()}`);
  }

  public saveEstacionamento(estacionamento: Estacionamento): Observable<any> {
    return this.save("estacionamentos/", estacionamento);
  }

  desativar(id: number) {
    return this.delete("estacionamentos/desativar/", id);
  }

  getEstacionamento(id: number) {
    return this.get("estacionamentos/", id);
  }
}
